export default __webpack_public_path__ + "static/media/construction.ddc26c79.png";